var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4634 5.4497L18.5502 6.53652C18.6928 6.67829 18.8059 6.84683 18.883 7.03246C18.9602 7.21809 18.9999 7.41714 18.9999 7.61817C18.9999 7.8192 18.9602 8.01825 18.883 8.20387C18.8059 8.3895 18.6928 8.55804 18.5502 8.69981L17.4634 9.78662L14.2133 6.53652L15.3001 5.4497C15.4419 5.30717 15.6104 5.19407 15.7961 5.1169C15.9817 5.03972 16.1807 5 16.3818 5C16.5828 5 16.7819 5.03972 16.9675 5.1169C17.1531 5.19407 17.3217 5.30717 17.4634 5.4497ZM5 19V15.7499L12.5767 8.17316L15.8268 11.4233L8.25011 19H5Z",
    fill: "#ACCAF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.573e0709947cfd313449851592e0f88e.svg";
export { ForwardRef as ReactComponent };